
<template>
  <div id="documents" v-if="showWindow">
      <vs-popup classContent="popup-example" title="Update document" :active.sync="popUps.updateDoc">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Doc name" v-model="params.doc_name" />
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Doc unique" v-model="params.doc_unique" />
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Status</label>
          <select v-model="params.status"  class="inputx w-full" label="Status">
            <option>declined</option>
            <option>approved</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Reason</label>
          <select v-model="params.reason" class="form-control inputx w-full">
              <option></option>
              <option>bad pic</option>
              <option>brand</option>
              <option>outdated</option>
              <option>mismatching details</option>
              <option>client request</option>
              <option>wrong doc</option>
              <option>compliance</option>
              <option>suspected fraud</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Comment" v-model="params.comment" />
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-checkbox class="inputx w-full" placeholder="Email" v-model="params.checkbox" >Email</vs-checkbox>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData()" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :line-details="params"
      :filters="filters"
      :buttons="buttons"
      :pop-ups="popUps"
      >
    </table-view>
  </div>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import tableView from '../../components/tableView';
import dealName from '../../../resources/deal_name.json';
import bizStatus from '../../../resources/biz_get_statuses.json';
import bizType from '../../../resources/biz_get_trantype.json';
import bizCurrency from '../../../resources/biz_get_currencies.json';
export default {
  components: {   
    tableView,
    vSelect,
    Datepicker
  },
  data() {
    
    let data = {
      params:{},
      dealName: dealName,
      bizStatus: bizStatus,
      bizCurrency:bizCurrency,
      bizType:bizType,
      bizAccounts:[],
      bizBen:[],
      bizService:[],
      endPoint:'documents',
      filters: {
        brokers: true,
        ver_status: true
      },
      buttons:{
          showDod: true,
          download: true
      },
      popUps:{
          updateDoc: false
      }
    }
    let firstColumns = {
      headerName: 'created_at',
      field: 'created_at',
      filter: "agNumberColumnFilter",
      width: 250,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      headerCheckboxSelection: true,
    };
    data.columnDefs= JSON.parse(localStorage.getItem('documentsColumns'));
    data.columnDefs.unshift(firstColumns);
    return data;
  },
  methods:{
    sendData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'update-doc');
      params.append('email', this.params.username);
      params.append('doc_name', this.params.doc_name);
      params.append('doc_unique', this.params.doc_unique);
      params.append('status', this.params.status);
      params.append('reason', this.params.reason);
      params.append('comment', this.params.comment);
      params.append('checkbox', this.params.checkbox);
      if(this.params.status=='declined' && (this.params.reason==='' || this.params.reason===undefined)){
        that.openAlert('danger','Failed','Reason can not be empty');
        return false;
      }
      this.$vs.loading();
      
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        that.popupActive = false;
        that.params = {};
        if(data.data[0].out1==='system busy')
          that.openAlert('danger','Failed',data.data[0].out1);
        else
          that.openAlert('success','Success',data.data[0].out1);
      })
      .catch((data) => { that.$vs.loading.close(); that.openAlert('danger','Failed',data[0].out1); })
    },
    openAlert(color,title,text) {
        let colorAlert = color;
        this.$vs.notify({
            title: title,
            text: text,
            color: colorAlert
        })
    }
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/documents'){
        return true;
      }
      return false;
    },
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}

</script>